import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from "../../shared/shared.module";
import {AdditionalPointRoutingModule} from "./additional-point-routing.module";
import {AdditionalPointEditComponent} from "./edit/additional-point-edit.component";
import {PointOfSaleModule} from "../pointOfSale/point-of-sale.module";
import {PointOfSaleServiceA2} from "../pointOfSale/point-of-sale.service";
import {TextMaskModule} from "angular2-text-mask";
import {SelectorComponent} from "./selector/selector.component";

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, AdditionalPointRoutingModule, TranslateModule, SharedModule, PointOfSaleModule, TextMaskModule],
    declarations: [AdditionalPointEditComponent, SelectorComponent],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    providers: [PointOfSaleServiceA2]
})
export class AdditionalPointModule {}


// WEBPACK FOOTER //
// ./public/upgrade/feature/additionalPoint/additional-point.module.ts